import React, { SVGProps } from 'react'

const SvgClose = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="none"
      stroke={props.stroke || 'var(--color-cta)'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m12.5 12.5 4.243-4.243L12.5 12.5 8.257 8.257 12.5 12.5Zm0 0-4.243 4.243L12.5 12.5l4.243 4.243L12.5 12.5Z"
    />
  </svg>
)
export default SvgClose
